(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('avgByDayReportController', avgByDayReportController);

  /** @ngInject */
  function avgByDayReportController ($scope, $translate, reportExportUtil, exportToCsv, AvgByDayReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new AvgByDayReportViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

    function exportCsv () {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('DAYS'),
          vm.report.chart.data,
          reportExportUtil.ValueFormattersEnum.DAY,
          reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
          $translate.instant('AVG_MONEY_BY_DAY_OF_WEEK_REPORT'),
          true);
    }

  }
})();
